/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type expiringPromoMessageHelpers_expiringPromotion = {
    readonly daysRelativeToExpiration: string | null;
    readonly promotionMeta: {
        readonly urgencyMessagingDisplay: boolean | null;
        readonly urgencyMessagingDaysBeforeExpiration: number | null;
    } | null;
    readonly " $refType": "expiringPromoMessageHelpers_expiringPromotion";
};
export type expiringPromoMessageHelpers_expiringPromotion$data = expiringPromoMessageHelpers_expiringPromotion;
export type expiringPromoMessageHelpers_expiringPromotion$key = {
    readonly " $data"?: expiringPromoMessageHelpers_expiringPromotion$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"expiringPromoMessageHelpers_expiringPromotion">;
};



const node: ReaderInlineDataFragment = {
    "kind": "InlineDataFragment",
    "name": "expiringPromoMessageHelpers_expiringPromotion"
} as any;
(node as any).hash = '89addd7466942b1e9d53058e1b0457f3';
export default node;
